import { Grid, Typography } from '@mui/material';

const Home = () => {
    return (
        <Grid
            container
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="90vh"
        >
            <Grid item textAlign="center" sm={12} md={10} lg={6}>
                <Typography
                    style={{ fontWeight: 'bold', fontSize: 50 }}
                    color="#000"
                >
                    Te damos la bienvenida al{' '}
                    <Typography
                        component="span"
                        color="primary"
                        style={{ fontSize: 50 }}
                    >
                        CRMWARE
                    </Typography>
                </Typography>
            </Grid>
        </Grid>
    );
};

export default Home;
